import { useEffect, useState } from "react";
import { useAuthenticatedFetch } from "./useAuthenticatedFetch";

export interface Template {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  previewImageUrl: string | null;
  category: string | null;
  isPremium: boolean;
  sortOrder: number;
}

export interface TemplateDetail extends Template {
  stylesConfig: Record<string, unknown>;
  isActive: boolean;
  minPlanRequired: string | null;
  createdAt: string;
  updatedAt: string;
}

export function useGetTemplates() {
  const authFetch = useAuthenticatedFetch();
  const [templates, setTemplates] = useState<Template[]>([]);

  useEffect(() => {
    let cancelled = false;

    authFetch("/api/admin/templates")
      .then((res) => (res.ok ? res.json() : Promise.reject(res.statusText)))
      .then((data: Template[]) => {
        if (!cancelled) {
          setTemplates(data);
        }
      })
      .catch((err) => {
        console.error("Failed to load templates:", err);
        if (!cancelled) setTemplates([]);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { templates };
}

export function useGetTemplateById(id: string | null) {
  const authFetch = useAuthenticatedFetch();
  const [template, setTemplate] = useState<TemplateDetail | null>(null);

  useEffect(() => {
    if (!id) return;
    let cancelled = false;

    authFetch(`/api/admin/templates/${id}`)
      .then((res) => (res.ok ? res.json() : Promise.reject(res.statusText)))
      .then((data: TemplateDetail) => {
        if (!cancelled) {
          setTemplate(data);
        }
      })
      .catch((err) => {
        console.error("Failed to load template:", err);
        if (!cancelled) setTemplate(null);
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  return { template };
}
